import './styles/alert-bar-base.scss';
import React, {Component, PropTypes} from 'react';

const defaultTimeoutLength = 6000;

function clearTimer(comp) {

    if (comp.state.timer) {

        global.clearTimeout(comp.state.timer);

    }

}

function setTimer(comp) {

    if (comp.props.willAutoDismiss) {

        comp.setState({
            timer: global.setTimeout(comp.props.dismissHandler, comp.props.timeoutLength)
        });

    }

}

class AlertBarBase extends Component {

    constructor(props) {

        super(props);
        this.state = {
            timer: null
        };

    }

    componentDidMount() {

        setTimer(this);

    }

    componentWillReceiveProps() {

        clearTimer(this);
        setTimer(this);

    }

    render() {

        const iconClasses = `icon ${this.props.iconClass}`;

        return (
            <div className='alert-bar-base'>
                <span className={iconClasses}></span>
                <div className='alert-bar-base-content'>
                    <div className='alert-bar-base-header'>
                        <span className='alert-bar-base-title'>{this.props.alertTitle}</span>
                        {this.props.isDismissable &&
                        <button
                            className='dismiss-btn icon-close-white'
                            onClick={this.props.dismissHandler}
                        />}
                    </div>
                    <div className='alert-bar-base-body'>
                        {this.props.children}
                    </div>
                </div>
            </div>
        );

    }
}

AlertBarBase.displayName = 'AlertBarBase';

AlertBarBase.propTypes = {
    alertTitle: PropTypes.any.isRequired,
    children: PropTypes.any.isRequired,
    dismissHandler: PropTypes.func.isRequired,
    iconClass: PropTypes.string.isRequired,
    isDismissable: PropTypes.bool,
    timeoutLength: PropTypes.number,
    willAutoDismiss: PropTypes.bool
};

AlertBarBase.defaultProps = {
    isDismissable: true,
    timeout: null,
    timeoutLength: defaultTimeoutLength
};

export default AlertBarBase;



// WEBPACK FOOTER //
// ./src/shared/components/alert-bar/alert-bar-base.js